<template>
  <v-card>
    <v-form @submit.prevent="submitEditClient()" ref="editClientForm">
      <v-container grid-list-lg>
        <v-layout wrap>
          <dialog-header :title="'Edit'" :details="client.name"></dialog-header>
          <v-flex xs12 sm6>
            <v-text-field
              v-model="editedClient.name"
              label="* Name"
              autofocus
              :loading="loading"
              :rules="nameRules"
              :color="primaryNeutral"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="* ABN"
              v-model="editedClient.abn"
              :rules="abnRules"
              :color="primaryNeutral"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              v-model="editedClient.contactEmail"
              label="Contact Email"
              :loading="loading"
              :rules="contactEmailRules"
              :color="primaryNeutral"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              v-model="editedClient.contactPhone"
              label="Contact Phone"
              :loading="loading"
              :rules="contactPhoneRules"
              :color="primaryNeutral"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div v-if="different">
          <v-btn :color="primaryGrey" flat @click="discard()">Discard?</v-btn>
          <v-btn :color="primaryGreen" flat type="submit" :loading="loading">Save</v-btn>
        </div>
        <div v-else>
          <v-btn :color="primaryGrey" flat @click="close()">Close</v-btn>
        </div>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import ClientService from "@/services/requests/clientService";

// MIXINS
import ClientValidation from "@/services/validation/clientValidation";

// COMPONENTS
import DialogHeader from "@/components/ui/dialogHeader";

export default {
  mixins: [ClientValidation],
  components: {
    DialogHeader
  },
  data() {
    return {
      editedClient: Object.assign({}, this.client),
      loading: false
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    discard() {
      this.editedClient = Object.assign({}, this.client);
      this.close();
    },
    submitEditClient() {
      if (!this.$refs.editClientForm.validate()) {
        return;
      }
      this.save();
    },
    save() {
      this.loading = true;
      ClientService.updateClient(this.editedClient)
        .then(result => {
          this.loading = false;
          this.$store.commit("clients/updateArrayStateByValue", {
            prop: "clients",
            value: this.client,
            editedValue: result.data.result.client
          });
          this.editedClient = Object.assign({}, result.data.result.client);
          this.snack({ color: "green", text: "Client was updated!" });
          this.close();
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
          this.snackError();
        });
    }
  },
  computed: {
    different() {
      if (!this._.isEqual(this.client, this.editedClient)) {
        return true;
      } else {
        return false;
      }
    }
  },
  props: {
    client: Object
  }
};
</script>

<style>
</style>
